/**
 * 購物車 state (Zustand)
 *
 * 設計:
 *  - server 是 source of truth(Firestore carts/{uid}),store 只是 cache
 *  - 任何寫操作 → call server → refresh from server(避免 stale)
 *  - 樂觀更新留待 Phase 2(現在求穩,延遲 200-500ms 可接受)
 */
import { create } from "zustand";
import type { Cart } from "../api/cart";
import { getCart, addToCart, updateCartQty, removeFromCart } from "../api/cart";

interface CartState {
  cart: Cart | null;
  loading: boolean;
  refresh: () => Promise<void>;
  add: (product_id: string, qty?: number) => Promise<void>;
  setQty: (product_id: string, qty: number) => Promise<void>;
  remove: (product_id: string) => Promise<void>;
  clear: () => void;
}

const EMPTY_CART: Cart = { items: [], total: 0, items_count: 0 };

export const useCartStore = create<CartState>((set) => ({
  cart: null,
  loading: false,
  refresh: async () => {
    set({ loading: true });
    try {
      const c = await getCart();
      set({ cart: c, loading: false });
    } catch {
      set({ cart: EMPTY_CART, loading: false });
    }
  },
  add: async (product_id, qty = 1) => {
    await addToCart(product_id, qty);
    const c = await getCart();
    set({ cart: c });
  },
  setQty: async (product_id, qty) => {
    await updateCartQty(product_id, qty);
    const c = await getCart();
    set({ cart: c });
  },
  remove: async (product_id) => {
    await removeFromCart(product_id);
    const c = await getCart();
    set({ cart: c });
  },
  clear: () => set({ cart: null }),
}));
